import { SNACKBARS_ADD, SNACKBARS_REMOVE, SNACKBARS_CLEAR } from "constants/action-types";
import { handleActions } from "redux-actions";
import { List } from "immutable";

export type Snackbar = {
    id: string;
    type: string;
    onActionClick?: () => void;
    options?: object;
    message?: string;
    actions?: Array<object>;
};

const initialState: List<Snackbar> = List();

const snackbarsReducer = handleActions(
    {
        [SNACKBARS_ADD]: (state: List<Snackbar>, { payload }): List<Snackbar> => {
            return List([payload]); // Keep current functionality for now, future: state.unshift(payload);
        },
        [SNACKBARS_REMOVE]: (state: List<Snackbar>, { payload }): List<Snackbar> =>
            state.filter((toast) => toast.id !== payload) as List<Snackbar>,
        [SNACKBARS_CLEAR]: (): List<Snackbar> => {
            return List();
        },
    } as any,
    initialState,
);

export default snackbarsReducer;
